import { Component, createRef } from "react"
import PropTypes from "prop-types"

import colors from "foundation/_colors_export.scss?export"
import classnames from "classnames"
import Fittty from "shared/components/fittty"
import { ctaCopyToConnect } from "../utils"
import { expireBFCache } from "shared/scripts/back_forward_cache_utils"

// Disconnect phase 2 (CSS transitions): mounts once the disable confirms, picks
// up ConnectButton's handoff frame (knob right, DSL "Loading" grey) and slides
// the knob left. Also renders the plain disconnected rest state.
export default class ReconnectButton extends Component {
  state = {
    phase: this.props.disconnectClicked ? "disconnecting" : "off",
    ctaCopy: this.props.disconnectClicked ? "Disconnecting" : "",
    animating: false,
  }

  buttonRef = createRef()

  componentDidMount() {
    // Disconnected state: reset the connect slide and the sign-in mark so the next
    // connect replays the slide and shows "Connecting" only after a new sign-in.
    this.props.updateAnimationCol?.({ animation: "connectSlide", status: { played: false } })
    this.props.updateAnimationCol?.({ animation: "showSuccessConnection", status: { played: false } })

    if (this.props.disconnectClicked) {
      this.slideToRest()
    } else {
      // Disabled on load (no click this session): settle in place.
      this.setState({ ctaCopy: this.restCopy() })
    }
  }

  slideToRest = () => {
    // Flush the handoff baseline so the knob slide + crossfades animate, not snap.
    if (this.buttonRef.current) void this.buttonRef.current.offsetWidth
    this.setState({ phase: "off", ctaCopy: this.restCopy(), animating: true })
  }

  restCopy = () => ctaCopyToConnect(this.props.dynamicConfig && this.props.mainService.short_name)

  handleClick = event => {
    event.preventDefault()
    expireBFCache()
    this.props.onConnectClick()
  }

  render() {
    const { phase, ctaCopy, animating } = this.state
    const { knobBgColorForDarkBrands, dynamicConfig, mainService } = this.props

    const knobRight = phase === "disconnecting"
    const hasIcon = dynamicConfig
    // With an icon the track stays #111 throughout; without one the handoff holds
    // the DSL "Loading" grey and the slide solidifies it to #111.
    const trackColor = !hasIcon && knobRight ? colors.connectButtonLoadingColor : colors.primaryTextColor
    const knobColor = knobRight && !hasIcon ? "#fff" : `#${mainService.brand_color}`

    return (
      <div className="connect-button-outline rc">
        <div
          ref={this.buttonRef}
          style={{ backgroundColor: trackColor }}
          className={classnames("connect-button", { "is-animating": animating })}
          onClick={this.handleClick}
        >
          <div
            id="connect-ball"
            className={classnames("service-icon", {
              "alt-brand-color": knobBgColorForDarkBrands,
              connected: knobRight,
            })}
            style={{ backgroundColor: knobColor }}
          >
            {hasIcon && (
              <img
                alt={mainService.name}
                title={mainService.name}
                src={mainService.lrg_monochrome_image_url || mainService.lrg_variant_image_url}
                width="40"
                height="40"
              />
            )}
          </div>
          <div className={classnames("connect-cta", { connected: knobRight })} id="cta-copy">
            <div>
              <Fittty maxSize={this.props.connectButtonMaxFontSize} minSize={14} text={ctaCopy} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

ReconnectButton.propTypes = {
  mainService: PropTypes.object.isRequired,
  onConnectClick: PropTypes.func.isRequired,
  disconnectClicked: PropTypes.bool.isRequired,
  connected: PropTypes.bool,
  dynamicConfig: PropTypes.bool,
  connectButtonMaxFontSize: PropTypes.number,
  knobBgColorForDarkBrands: PropTypes.bool,
  updateAnimationCol: PropTypes.func,
}

ReconnectButton.defaultProps = {
  connected: false,
  connectButtonMaxFontSize: 34,
}
